import API from "../utils/api";
import axios from "axios";

export const getShopifyPayoutsApi = async (data) => {
    const response = await API.get('report/payments/payouts', {
        params: data,
    });
    return { response };
};

export const generatePaymentsApi = async (data) => {
    const response = await API.post(`report/payments/payouts/generate`, data);
    return { response };
};

export const sendToXeroApi = async (data) => {
    const response = await API.post(`report/payments/payouts/send-to-xero`, data);
    return { response };
};

export const getShopifyPayoutDetailsApi = async (data) => {
    const response = await API.get(`report/payments/shopify-payout-details/${data.id}`, {
        params: data,
    });
    return { response };
};

export const exportShopifyPayoutDetailApi = async (data) => {
    const response = await API.get(`report/payments/shopify-payout-details/${data.id}/export`, {
        params: data,
    });
    return { response };
};

export const getShopifyPayoutXeroInvoicesApi = async (data) => {
    const response = await API.get(`report/payments/shopify-payout/xero-invoices`, {
        params: data,
    });
    return { response };
};

